import classNames from "classnames";

export const Box = ({ children, ...rest }) => {
	return (
		<div
			{...rest}
			className={classNames({
				"cursor-pointer": true,
				"bg-white border-b md:border border-zinc-200": true,
				"flex w-full justify-between box-border md:rounded-2xl p-4": true,
			})}>
			{children}
		</div>
	);
};
